import Main from '../../types/enums/main';
import Rail from '../../classes/rail';
import generateChannelsRails from '../../utils/generic/generateChannelsRails';
import slidersObservable from '../sliders/slidersObservable';
import { Observable, merge } from 'rxjs';
import { store } from '../../store/store';

const WAITING_TIME = 100;

export default function initialObservable() {
  const data: Rail[] = [];
  return merge(
    slidersObservable(''),
    new Observable((subscriber) => {
      const [filterRail, channelsRail, nowOnTvRail] = generateChannelsRails();
      subscriber.next({ data: filterRail, type: Main.FILTER });
      subscriber.next({ data: channelsRail, type: Main.CHANNELS });
      data.push(nowOnTvRail);
      setTimeout(() => {
        const { keepWatching } = store.getState();
        if (keepWatching.data.length) {
          const keepWatchingRail = keepWatching.rail;
          if (keepWatchingRail) {
            data.push(keepWatchingRail);
          }
        }
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    })
  );
}
